import { RequisitionLine } from "./requisition-line";
import { User } from "./user";

export class Requisition {
    id:number = 0;
    reference:string = '';
    doc_date:Date = new Date();
    delivery_date:Date = new Date();
    description:string = '';
    status:string = 'Abierto';
    user_id:number = 0;
    user:User = new User();
    lines:RequisitionLine[] = [];
    selected:boolean = false;
    authorized:boolean = false;
    authorized_by:User = new User();
}
